var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorUnderwear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.849,17.383l-2.588,1.838c-1.707,1.212-3.994,1.213-5.701,0l-.412-.293c-1.041-.739-1.755-1.853-1.99-3.108h0c-.221-1.177-.005-2.395.607-3.424h0c.512-.861.763-1.851.723-2.852l-.255-6.428,1.813-.315.709,6.857s5.044.788,7.566,5.99c.079.158,1.278.158,1.357,0,2.522-5.202,7.566-5.99,7.566-5.99l.709-6.857,1.813.315-.255,6.428c-.04,1,.212,1.991.723,2.852h0c.612,1.03.828,2.247.607,3.424h0c-.235,1.255-.949,2.369-1.99,3.108l-.412.293c-1.707,1.212-3.994,1.211-5.701,0l-2.588-1.838h-2.303Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m18.055,38.92c-.324-.37-.833-2.407-2.685-4.352s-6.481-3.287-6.528-3.287c.324-1.898,1.389-2.917,1.574-2.963,2.361.532,6.472,1.867,10.584,1.867,4.111,0,8.223-1.335,10.584-1.867.185.046,1.25,1.065,1.574,2.963-.046,0-4.676,1.343-6.528,3.287s-2.361,3.981-2.685,4.352c-.162.185-1.553.278-2.945.278s-2.783-.093-2.945-.278Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorUnderwear);
export default __webpack_public_path__ + "static/media/indoor-underwear.ab07b2bdd403075fdeb1b9e4c00a8c35.svg";
export { ForwardRef as ReactComponent };